import * as React from 'react';
import { SeasonPreviewBackground } from './SeasonPreviewBackground';
import { MoloLoginLogo } from './MoloLoginLogo';
/** Samme login-ramme som hub salesbook Login.cshtml (marquee + logo + glass form). */
export var SeasonPreviewLoginLayout = function (_a) {
    var children = _a.children, seasonCode = _a.seasonCode;
    React.useEffect(function () {
        document.body.classList.add('home_login', 'season-preview-login-page');
        return function () {
            document.body.classList.remove('home_login', 'season-preview-login-page');
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(SeasonPreviewBackground, { id: "season-preview-login-host", className: "season-preview-background-host", seasonCode: seasonCode }),
        React.createElement("div", { id: "season-preview-login-logo", className: "season-preview-login-logo molo-logo-blend", "aria-hidden": "true" },
            React.createElement(MoloLoginLogo, { className: "molo-logo-blend__svg login-form__logo" })),
        React.createElement("div", { className: "season-preview-login-ui" },
            React.createElement("div", { className: "season-preview-login-ui__stack" },
                React.createElement("div", { className: "season-preview-login-ui__logo-spacer", "aria-hidden": "true" }),
                children))));
};
//# sourceMappingURL=SeasonPreviewLoginLayout.js.map